import React, { Suspense } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from 'application/providers/AuthProvider';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

export const SPECIAL_REGISTER_PAGE_PATH = '/register/:source';

export enum SourceParamValues {
  YCLIENTS = 'yclients',
  ACTIVATION = 'activation',
}

export type SpecialRegisterPageParamsType = {
  source?: string | SourceParamValues;
};

const Renderer = React.lazy(() => import('./renderer'));

const SpecialRegisterPageWrapper: IApplicationPage = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

SpecialRegisterPageWrapper.config = {
  routes: [
    {
      path: SPECIAL_REGISTER_PAGE_PATH,
    },
  ],
  access: [LocalAccessRoles.ANONYMOUS],
};

export default SpecialRegisterPageWrapper;
